export default "__VITE_ASSET__e0bdafe9__"